$(document).on("click", ".productFinderBtn", () => {
  const handle = $($(".productFinderCard select")[0]).val();
  const filter = $($(".productFinderCard select")[1]).val();

  console.log(handle);
  console.log(filter);

  const filterString = {
    min_100: "filter.v.price.lte=100",
    "100_200": "filter.v.price.gte=100&filter.v.price.lte=200",
    "200_300": "filter.v.price.gte=200&filter.v.price.lte=300",
    "300_400": "filter.v.price.gte=300&filter.v.price.lte=400",
    "400_max": "filter.v.price.gte=400",
  };

  let url = `/collections/${handle}?${filterString[filter]}`;

  window.location.href = url;
});
